import { getCurrentAccount } from 'redux/selectors/accounts';
import { getUserId } from 'redux/selectors/user';
import type { IState } from 'redux/state';
import { createSelector } from 'reselect';
import { dayPropertiesAdapter, isDayLockedForUser } from './dayProperties';
import type { DayProperties } from './dayProperties.schema';

const selectors = dayPropertiesAdapter.getSelectors<IState>(state => state.dayProperties);

/**
 * Whether the `day_locking` account feature is enabled. Mirrors the inline
 * `!!account.features.day_locking` derivation used by the calendar selectors
 * (e.g. `getCalendarRouteUi`); exported here, co-located with the day-lock
 * readers, so loaders can gate the `day_properties` fetch the same way
 * `CalendarRoute` gates `loadDayPropertiesForCalendar`.
 */
export const getIsDayLockingFeatureEnabled = createSelector(
  getCurrentAccount,
  account => !!account.features.day_locking
);

export const getDayProperties = createSelector(selectors.selectAll, dayProperties => {
  return dayProperties.reduce(
    (acc, property) => {
      const date = property.date;
      acc[date] ??= [];
      acc[date].push(property);
      return acc;
    },
    {} as Record<string, Array<DayProperties>>
  );
});

export const getIsDayLockedByDate = createSelector(
  getUserId,
  getDayProperties,
  (_, date: string) => date,
  (userId, dayProperties, date) => isDayLockedForUser(userId, dayProperties[date])
);
